var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 53,
    viewBox: "0 0 59 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3839 17.3849C58.3839 17.3848 58.3839 17.3848 58.3839 17.3847C58.3839 7.8136 50.625 0.0546875 41.0539 0.0546875C36.6154 0.0546875 32.5666 1.7233 29.5006 4.46745C26.4346 1.7233 22.3857 0.0546875 17.9472 0.0546875C8.3761 0.0546875 0.617188 7.8136 0.617188 17.3847C0.617188 17.3848 0.617188 17.3849 0.617188 17.385C0.617188 38.6174 19.8866 48.5965 26.9473 51.5404C28.5921 52.2261 30.4091 52.2261 32.0538 51.5404C39.1145 48.5965 58.3839 38.6173 58.3839 17.3849Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M57.8842 23.16H44.4023L40.82 14.8013C40.3649 13.7394 39.3206 13.0508 38.1652 13.0508C37.0098 13.0508 35.9656 13.7394 35.5104 14.8013L29.5002 28.8252L27.8225 24.9105C27.3674 23.8485 26.3231 23.16 25.1677 23.16H1.11621C1.47955 25.2083 2.02951 27.1321 2.7274 28.9366H23.2631L26.8454 37.2953C27.3006 38.3572 28.3448 39.0458 29.5002 39.0458C30.6556 39.0458 31.6999 38.3572 32.155 37.2953L38.1652 23.2714L39.8429 27.1861C40.2981 28.2481 41.3423 28.9366 42.4977 28.9366H56.273C56.9709 27.1321 57.5209 25.2083 57.8842 23.16Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBeat);
export default __webpack_public_path__ + "static/media/heartBeat.1253e36dd19eccacf6cd4566014e7663.svg";
export { ForwardRef as ReactComponent };